import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "projects-list" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "active" }
const _hoisted_5 = { class: "budget" }
const _hoisted_6 = {
  key: 0,
  class: "loading apollo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EntitiesList = _resolveComponent("EntitiesList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("labels.project.name")), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("labels.project.active")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t("labels.project.budget")), 1),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))
        ]),
        (_ctx.client)
          ? (_openBlock(), _createBlock(_component_EntitiesList, {
              key: 0,
              "has-icon": false,
              elements: _ctx.client.projects,
              formatters: {
          budget: _ctx.formatBudget,
        },
              onGoEntityDetails: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewEntity($event)))
            }, null, 8, ["elements", "formatters"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t("loading")), 1))
      : _createCommentVNode("", true)
  ], 64))
}